import { CommonHttpOption } from "./../../base/common-http-option";
import { CoreService } from "./../../base/core";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ServiceRoute } from "../../base/service-route";
import { IHolding } from "src/app/interfaces/holding";

@Injectable({
  providedIn: "root"
})
export class HoldingService {
  constructor(private core: CoreService) {}

  list(): Observable<any> {
    return this.core.get(
      ServiceRoute.holding.list,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(0, 0)
    );
  }

  allList(): Observable<any> {
    return this.core.get(
      ServiceRoute.holding.AllList,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(0, 0)
    );
  }
  getById(id: number): Observable<any> {
    return this.core.get(
      ServiceRoute.holding.getById + id,
      new CommonHttpOption().headers,
      new CommonHttpOption().params
    );
  }

  add(data: IHolding): Observable<any> {
    return this.core.post(
      ServiceRoute.holding.add,
      data,
      new CommonHttpOption().headers
    );
  }

  edit(data: IHolding): Observable<any> {
    return this.core.put(
      ServiceRoute.holding.edit,
      data,
      new CommonHttpOption().headers
    );
  }

  delete(guid: string): Observable<any> {
    return this.core.delete(
      ServiceRoute.holding.delete + guid,
      new CommonHttpOption().headers
    );
  }

  checkOwnerHolding(): Observable<any> {
    return this.core.get(
      ServiceRoute.holding.checkOwnerHolding,
      new CommonHttpOption().headers
    );
  }
}
